// RBAC role that confers administrator privileges upon users of any account
import { SYSTEM_DOMAIN_ROLES } from './autogen/role-permissions';
import type { RoleName, RoleNames } from './system.models';

export const SYSTEM_ADMIN: RoleName = 'system-admin';

// RBAC roles to exclude from account-scoped role dropdowns. Combines
// system-admin (which is functionally a wildcard role surfaced via the
// separate Admin toggle) with the autogenerated set of roles Platform
// restricts to the system domain.
export const systemRoles: RoleNames = [SYSTEM_ADMIN, ...SYSTEM_DOMAIN_ROLES];

export const SYSTEM_COMPONENTS = ['services', 'feeds'] as const;

export const SYSTEM_STATUS_ITEMS = ['system', ...SYSTEM_COMPONENTS] as const;

export const SYSTEM_ROLE_OPTIONS = systemRoles.map(role => ({
  key: role,
  text: role,
  value: role,
}));
